import IndexPage from 'flarum/forum/components/IndexPage';

export default class AllDiscussionsPage extends IndexPage {
  // This component extends IndexPage directly, so it will render
  // the original discussion list exactly as the homepage used to
}
